import React from "react";
import { FaBowlFood, FaHeartPulse, FaLocationDot, FaUsers } from "react-icons/fa6";
import OverlapSection from "../section/OverlapSection";
import imageSrc from "../../assets/images/MissingDog.jpg";
import "./features.css";

const feederActions = [
  {
    icon: <FaLocationDot />,
    title: "Add a feeding point",
    text: "Help neighbours find the places you regularly feed, along with the animals who depend on that spot.",
  },
  {
    icon: <FaBowlFood />,
    title: "Share care updates",
    text: "Post a simple update about food, water, or a changed routine so care continues even when you are unavailable.",
  },
  {
    icon: <FaHeartPulse />,
    title: "Flag health concerns early",
    text: "Use the network to make the community aware when an animal looks injured, unwell, new to the area, or needs attention.",
  },
  {
    icon: <FaUsers />,
    title: "Bring local helpers together",
    text: "Connect feeders, rescuers, and nearby animal lovers around each feeding area for more reliable everyday care.",
  },
];

const StrayNetwork = () => {
  return (
    <section id="network" className="feature-section-anchor feeder-network">
      <OverlapSection
        layoutClass="toRight"
        imageUrl={imageSrc}
        mainTitle="FEED TOGETHER. CARE FURTHER."
        backText="Stray Network helps feeders turn a daily act of care into a shared local support system for the animals they know."
      />

      <div className="feeder-network__content">
        <div className="feeder-network__intro">
          <p>For feeders</p>
          <h2>Your routine can help the whole community respond better</h2>
          <span>Instapaw's animal feeder network helps stray dog feeders share the right information at the right time, so no animal is cared for by just one person.</span>
        </div>

        <div className="feeder-network__grid">
          {feederActions.map((action) => (
            <article className="feeder-network__card" key={action.title}>
              <span className="feeder-network__icon" aria-hidden="true">{action.icon}</span>
              <h3>{action.title}</h3>
              <p>{action.text}</p>
            </article>
          ))}
        </div>

        <p className="feeder-network__footer">Feed. Update. Connect. Small actions create a stronger safety net for every stray.</p>
      </div>
    </section>
  );
};

export default StrayNetwork;